import { render, staticRenderFns } from "./OwnershipForm.vue?vue&type=template&id=94a21554"
import script from "./OwnershipForm.vue?vue&type=script&lang=js"
export * from "./OwnershipForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports